<template>
  <el-carousel
      ref="gjCarousel"
      v-bind="$attrs"
      v-on="$listeners"
      :autoplay="autoplay"
      :loop="loop"
      :indicator-position="indicatorPosition"
      :arrow="arrow"
  >
    <el-carousel-item v-for="item in list" :key="item">
      <slot :name="item">
        <div>{{item}}</div>
      </slot>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: "gj-carousel",
  props:{
    //幻灯片列表
    list:{
      type:Array,
      default: function (){
        return ['one','two','three']
      }
    },
    //是否自动切换
    autoplay:{
      type:Boolean,
      default: false
    },
    //是否循环显示
    loop:{
      type:Boolean,
      default: false
    },
    //指示器的位置
    indicatorPosition:{
      type:String
    },
    //切换箭头的显示时机
    arrow:{
      type:String,
      default: 'never'
    },
  }
}
</script>

<style scoped lang="scss">

</style>